module.exports = __webpack_public_path__ + "assets/img/DS-room3 (11).bcab8ba7.jpg";